import DashboardModuleInfo from '@/model/user/DashboardModuleInfo'

export default class DashboardServiceInfo {
  dataKey: string = ''
  name: string = ''
  key: string = ''
  description: string = ''
  dashBoardModules: DashboardModuleInfo[] = []

  constructor(name: string, key: string) {
    this.name = name
    this.key = key
  }
}
